import {usersConstants} from '../constants';
import {getAuthToken} from '../../utils';

let token = getAuthToken();
const initialState = token ? { loggedIn: true, token: token, permissions: {}} : {};

const users = (state = initialState, action) => {
    switch (action.type) {
        case usersConstants.LOGIN_SUCCESS:
            return {
                ...state,
                loggingIn: true,
                user: action.user,
            };

        case usersConstants.SET_PERMISSIONS:
            return {
                ...state,
                permissions: action.permissions
            };
        default:
            return state
    }
};

export default users


// WEBPACK FOOTER //
// ./src/redux/reducers/users.reducer.js